// icb_dashboard.component.ts
import { Component, ViewChild, OnInit, Input, OnChanges, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Router } from '@angular/router';
import { HttpService } from '../shared/services/http.service';
import { dashboardResultService } from '../dashboardResultService';
import { SessionHandler } from '../shared/services/session-handler.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { PagedData } from "./datatable/paged-data";
import { Page } from "./datatable/page";
import { MdDialog, MdDialogRef } from '@angular/material';
import { CommonService } from '../shared/services/common.service';
import { dialogComponent } from '../dialog/dialog.component';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { filter } from 'rxjs/operators/filter';
import { SelectComponent } from 'ng2-select';
import { TranslateService, LangChangeEvent } from 'ng2-translate';
import { searchDialog } from '../dashboard/dashboard.component';

@Component({
    selector: 'my-dashboard',
    template: require('./icb_dashboard.component.html'),
    styles: [require('./icb_dashboard.component.scss'),require('../../../src/app/style.scss')],
    providers: [HttpService, SessionHandler]
})
export class icb_dashboardComponent implements OnInit, OnDestroy {
    @ViewChild(DatatableComponent) table: DatatableComponent;

    tableRows: any = [];
    page = new Page();
    public rows: any;
    dashboardData = [];
    temp = [];
    showTable: boolean = true;
    userData: any;
    dialogRef;
    isAdmin: boolean = false;
    userRole: any;
    tradePartnerId: any;
    offset: any;
    totalCount: any;
    allFilterData = [];
    searchfilterInptValue = '';
    tableScralled: boolean = false;
    private langSub: Subscription;
    private translateSub: Subscription;
    private isDestroyed = false;

    // language dropdown properties
    languages: string[] = ['English', 'French', 'Italian', 'German'];
    selectedLanguage: string = 'English';

    // optional columns array - leave undefined if you prefer template-defined columns
    columns: any;

    constructor(
        private router: Router,
        private http: HttpService,
        private serverResultsService: dashboardResultService,
        private sessionHandler: SessionHandler,
        public dialog: MdDialog,
        private commonService: CommonService,
        private translate: TranslateService,
        private cd: ChangeDetectorRef
    ) {
        this.page.pageNumber = 0;
        this.page.size = 50;

        // session & auth setup
        if (this.http.checkSession()) {
            this.commonService.setData(null);
            this.sessionHandler.saveItem("t2cCount", '1');
            this.sessionHandler.saveItem("t2tCount", '1');
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            if (this.userData && Object.keys(this.userData).length > 0 && this.userData.role && this.userData.role.length > 0) {
                if (this.userData.role.includes('ADMIN')) {
                    this.isAdmin = true;
                }
                if (this.userData && this.userData.role && this.userData.role.length > 0) {
                    this.userRole = this.userData.role.join();
                }
                if (this.isAdmin) {
                    this.tradePartnerId = "";
                }

                console.log("Role=************" + this.userData.role);
                console.log("tradePartnerId=**************" + this.userData.tradePartnerId);
                if (this.userData.role.includes('TRADE_PARTNER')) {
                    if (this.userData.tradePartnerId || this.userData.tradePartnerId != undefined) {
                        this.tradePartnerId = this.userData.tradePartnerId;
                    }
                } else {
                    this.tradePartnerId = this.userData.tradePartnerId;
                }

                this.offset = this.page.pageNumber * this.page.size;
                this.getMagFaultDesc();
                // getDashboardData will be called after language init below
            }
        } else {
            this.http.showSessionError();
        }

        // --- initialize language (try saved value) ---
        try {
            const saved = (typeof localStorage !== 'undefined') ? localStorage.getItem('appLanguage') : null;
            if (saved && this.languages.indexOf(saved) !== -1) {
                this.selectedLanguage = saved;
                this.translate.use(saved);
            } else {
                this.selectedLanguage = 'English';
                this.translate.setDefaultLang('English');
                this.translate.use('English');
                // persist default
                if (typeof localStorage !== 'undefined') {
                    localStorage.setItem('appLanguage', 'English');
                }
            }
        } catch (e) {
            console.warn('Language init error', e);
        }

        // subscribe to commonService language changes so other components can broadcast
        try {
            this.langSub = this.commonService.langChange.subscribe((lang: any) => {
                if (!lang || this.isDestroyed) return;
                if (this.languages.indexOf(lang) === -1) return;
                this.selectedLanguage = lang;
                try {
                    this.translate.use(lang);
                    if (typeof localStorage !== 'undefined') {
                        localStorage.setItem('appLanguage', lang);
                    }
                } catch (e) {
                    console.warn('translate.use failed in langChange subscriber', e);
                }
                // refresh table with language-aware API param
                this.getDashboardData();
            });
        } catch (e) {
            console.warn('Lang change subscription failed', e);
        }

        // subscribe to translate service (for UI re-render like headers)
        try {
            this.translateSub = this.translate.onLangChange.subscribe((evt: LangChangeEvent) => {
                if (this.isDestroyed) { return; } // don't run after destroy
                setTimeout(() => this.rebuildDatatableHeaders(), 0);
            });
        } catch (e) {
            console.warn('Translate onLangChange subscription failed', e);
        }
    }

    ngOnInit() {
        // initial data fetch (language already set in constructor)
        this.getDashboardData();
    }

    ngOnDestroy() {
        this.isDestroyed = true;
        if (this.langSub) {
            try { this.langSub.unsubscribe(); } catch (e) {}
        }
        if (this.translateSub) {
            try { this.translateSub.unsubscribe(); } catch (e) {}
        }
    }

    // language switcher method - called from template (dropdown change)
    public changeLanguage(lang: string) {
        if (!lang) { return; }
        if (this.languages.indexOf(lang) === -1) { return; }
        try {
            this.translate.use(lang);
            this.selectedLanguage = lang;
            if (typeof localStorage !== 'undefined') {
                localStorage.setItem('appLanguage', lang);
            }
        } catch (e) {
            console.error('Language change failed', e);
        }
        // notify other components that language changed
        try {
            this.commonService.changeLanguage(lang);
        } catch (e) {
            console.warn('commonService.changeLanguage failed', e);
        }
        // refresh dashboard data with new language param
        this.getDashboardData();
    }

    // map human language name to backend userLanguage code
    private mapLangToCode(lang: string): string {
        if (!lang) return 'EN';
        switch ((lang || '').toLowerCase()) {
            case 'french': return 'FR';
            case 'italian': return 'IT';
            case 'german': return 'DE';
            case 'english':
            default: return 'EN';
        }
    }

    // helper to force datatable header re-render on language change
    private rebuildDatatableHeaders() {
        if (this.isDestroyed) return;

        try {
            if (this.columns && Array.isArray(this.columns)) {
                this.columns = this.columns.map(c => Object.assign({}, c));
            } else {
                this.showTable = false;
                setTimeout(() => {
                    if (!this.isDestroyed) { this.showTable = true; }
                }, 0);
            }

            try {
                this.cd.detectChanges();
            } catch (err) {
                console.warn('detectChanges skipped because view is destroyed', err);
            }

            if (this.table && (this.table as any).recalculate) {
                try {
                    (this.table as any).recalculate();
                } catch (err) {
                    console.warn('datatable recalculate failed', err);
                }
            }
        } catch (err) {
            console.warn('datatable refresh error', err);
        }
    }

    // in icb_dashboard.component.ts (inside the class)
    openFileUploadPage() {
        // navigate to your file upload route
        this.router.navigateByUrl('/app/icb/file-upload');
    }

    // optional: inline file selected handler (if using Option B)
    onInlineFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) return;
        const file = input.files[0];
        // minimal validation example (size + extension)
        const maxBytes = 5 * 1024 * 1024;
        const validExt = /\.(xls|xlsx|csv)$/i.test(file.name);
        if (!validExt) {
          alert('Invalid file type. Allowed: .xls .xlsx .csv');
          input.value = '';
          return;
        }
        if (file.size > maxBytes) {
          alert('File too large. Max 5 MB');
          input.value = '';
          return;
        }
        // now send file to upload component/service or navigate to the upload page
        // e.g. save the file to a shared service and navigate to upload page to continue
        // this.commonService.setPendingUpload(file);
        // this.router.navigateByUrl('/app/icb/file-upload');
    }

    public getMagFaultDesc() {
        // placeholder - original call commented out
        // this.http.getRequest('masterData/v1/getMagMastandFaultItemsDetails')
        // .subscribe(res => { this.saveMagFaultDesc(res); }, err => { ... });
    }

    public advanceSearch() {
        this.dialogRef = this.dialog.open(icbSearchDialog);
    }

    public saveMagFaultDesc(res) {
        if (res && res.responseCode == '200') {
            if (res.faultMastList) {
                this.sessionHandler.saveItem('FaultList', JSON.stringify(res.faultMastList));
            }
            if (res.magMastList) {
                this.sessionHandler.saveItem('magList', JSON.stringify(res.magMastList));
            }
            if (res.salutationList) {
                this.sessionHandler.saveItem('salutationList', JSON.stringify(res.salutationList));
            }
        }
    }

    setPage(pageInfo, rows, filter) {
        this.page.pageNumber = pageInfo.offset;

        this.serverResultsService.getResults(this.page, rows).subscribe(pagedData => {
            console.log(pagedData);
            this.page = pagedData.page;
            this.tableRows = pagedData.data;
            if (!filter) {
                this.searchfilterInptValue = '';
                if (Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']) {
                    this.offset = this.page.pageNumber * this.page.size;
                    console.log(this.offset);
                    this.getDashboardData();
                }
            }
        });

        console.log(pageInfo);
        console.log(this.page);
    }

    public getDashboardData() {
        if (!this.tableScralled) {
            // include userLanguage param mapped from selectedLanguage
            const userLangCode = this.mapLangToCode(this.selectedLanguage);
            const url = 'serviceOrder/v1/listServiceOrders?offset=' + this.offset
                      + '&tradePartnerId=' + (this.tradePartnerId || '')
                      + '&userRoles=' + (this.userRole || '')
                      + '&userLanguage=' + userLangCode;

            this.http.getRequest(url)
                .subscribe(
                    (res: any) => {
                        this.saveDashboardData(res); 
                    },
                    err => {
                        if (err && err.status != 0) {
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = err;
                        }
                        this.http.onEnd();
                    }
                );
        }
    }

    handleScroll() {
        this.tableScralled = true;

        setTimeout(() => {
            this.tableScralled = false;
        }, 500);
    }

    public saveDashboardData(res) {
        this.http.showLoader();
        if (res.status == 'Success') {
            if (res && Object.keys(res).length > 0) {
                this.dashboardData = res;
                this.rows = [];
                this.rows['offSet'] = res.offSet;
                if (this.dashboardData && Object.keys(this.dashboardData).length > 0) {
                    if (this.dashboardData['items'] && this.dashboardData['items'].length > 0) {
                        this.totalCount = 0;
                        if (parseInt(res.offSet) == 0) {
                            localStorage.setItem('totalIcbCount', res.itemCount);
                            this.totalCount = parseInt(res.itemCount);
                        } else {
                            this.totalCount = parseInt(localStorage.getItem('totalIcbCount'));
                        }
                        this.rows['total_count'] = this.totalCount;
                        for (let data in this.dashboardData['items']) {
                            this.rows[data] = {};
                            this.rows[data]['serialNumberId'] = this.dashboardData['items'][data]['serviceOrderId'];
                            this.rows[data]['refCode'] = this.dashboardData['items'][data]['refCode'];
                            this.rows[data]['serviceOrderId'] = this.dashboardData['items'][data]['sapSORequestOrderId'];
                            this.rows[data]['contactEmail'] = this.dashboardData['items'][data]['contactEmail'];
                            this.rows[data]['faultDescription'] = this.dashboardData['items'][data]['faultDescription'];
                            this.rows[data]['mag'] = this.dashboardData['items'][data]['mag'];
                            this.rows[data]['modelNumber'] = this.dashboardData['items'][data]['modelNumber'];
                            this.rows[data]['serialNumber'] = this.dashboardData['items'][data]['serialNumber'];
                            this.rows[data]['sapSORequestOrderId'] = this.dashboardData['items'][data]['sapSORequestOrderId'];
                            this.rows[data]['upsTrackingNo'] = this.dashboardData['items'][data]['upsTrackingNo'];
                            this.rows[data]['currentStatus'] = this.dashboardData['items'][data]['currentStatus'];

                            this.temp = this.rows;
                        }
                        let finalRows = [];
                        for (let f in this.rows) {
                            if (f != 'offSet' && f != 'total_count' && this.rows[f]) {
                                finalRows.push(this.rows[f]);
                            }
                            if (f == 'offSet') {
                                finalRows['offSet'] = this.rows['offSet'];
                            }
                            if (f == 'total_count') {
                                finalRows['total_count'] = this.rows['total_count'];
                            }
                        }
                        this.rows = finalRows;
                        this.setPage({ offset: this.rows['offSet'] / this.page.size }, finalRows, true);
                    }
                } else {
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = res.errorMessage;
                }
            }
            this.allFilterData = JSON.parse(JSON.stringify(this.rows));
        }

        setTimeout(() => {
            this.http.onEnd();
        });
    }

    public formNavigate(type) {
        if (type == 't2t') {
            this.router.navigateByUrl('/app/icb/trade/data');
        }
        if (type == 't2c') {
            this.router.navigateByUrl('/app/icb/consumer/data');
        }
    }

    filterDatatable(event) {
        this.searchfilterInptValue = event;
        let data = this.commonService.filterDatatable(event, this.allFilterData);
        console.log(data);
        this.rows = data.data;
        this.dashboardData['items'] = this.rows;
        this.dashboardData['itemCount'] = this.rows.length;
    }
}

/* ----- search dialog component (kept inline as in your original file) ----- */

@Component({
    template: require('./search.component.html'),
    providers: [HttpService, SessionHandler]
})
export class icbSearchDialog implements OnInit {
    searchForm: FormGroup;
    searchParams: any = {};
    isFS: boolean = false;
    isApprover: boolean = false;
    isAdmin: boolean = false;
    isOTD: boolean = false;
    isEndConsumner: boolean = false;
    isOrderDesk: boolean = false;
    res: any;
    usersData = [];
    formData: any;
    statusList: any;
    shipment: any;
    reason: any;
    selectedStatus: any;
    daterange: any = {};
    public mapping = [
        {
            'serviceOrderId': 'Service Order ID',
            'contactEmail': 'Contact Email',
            'faultDescription': 'Fault Description',
            'lastUpdatedOn': 'Last Updated On',
            'returnReason': 'Return Reason',
            'createdBy': "Crated By",
            'status': 'Status',
            'serialNumber': 'Serial Number',
            'serialNumberId': 'Id',
            'refCode': 'Reference Code',
            'currentStatus': 'Status',
            'upsTrackingNo': 'UPS Tracking Number'
        }
    ];

    constructor(private formBuilder: FormBuilder, private daterangepickerOptions: DaterangepickerConfig, public dialog: MdDialog, private commonService: CommonService) {
        this.searchParams.display = {};
        this.searchParams.filters = {};
        this.searchParams.filters.status = [];
        this.searchParams.display.Status = [];
        this.shipment = ["Parcel", "Pallet"];
        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];
        var today = new Date();
        this.daterange.date = today.getDate();
        if (today.getMonth() == 0 || today.getMonth() == 1) {
            this.daterange.start_mm = 12;
            this.daterange.end_mm = 2;
            this.daterange.startYear = today.getFullYear() - 1;
            this.daterange.endYear = today.getFullYear();
        } else {
            this.daterange.start_mm = today.getMonth() - 1;
            this.daterange.end_mm = today.getMonth() + 1;
            this.daterange.startYear = today.getFullYear();
            this.daterange.endYear = today.getFullYear();
        }
        this.searchParams['display']['Date Interval'] = monthNames[this.daterange.start_mm - 1] + ' ' + this.daterange.date + ' ' + this.daterange.startYear + ' - ' + monthNames[this.daterange.end_mm - 1] + ' ' + this.daterange.date + ' ' + this.daterange.endYear;
        this.searchParams['filters']['startDate'] = this.daterange.startYear + '-' + this.daterange.start_mm + '-' + this.daterange.date;
        this.searchParams['filters']['endDate'] = this.daterange.endYear + '-' + this.daterange.end_mm + '-' + this.daterange.date;

        this.daterangepickerOptions.settings = {
            locale: { format: 'YYYY-MMM-D' },
            alwaysShowCalendars: false,
            startDate: new Date(this.daterange.startYear, this.daterange.start_mm - 1, this.daterange.date),
            endDate: new Date(this.daterange.endYear, this.daterange.end_mm - 1, this.daterange.date),
            buttonClasses: "btn",
            opens: 'center'
        };
    }

    ngOnInit(): void {
        if (this.isFS) {
            this.statusList = [{ text: "Approved", id: "APPR" }, { text: "Arrived", id: "Arrived" }];
            this.selectedStatus = 'APPR';
        } else if (this.isApprover || this.isAdmin || this.isOTD) {
            this.statusList = [{ text: "Approval Pending", id: "Submit" }, { text: "Approved", id: "APPR" }, { text: "Rejected", id: "REJE" }, { text: "Arrived", id: "Arrived" }];
        } else {
            this.statusList = [{ text: "Approval Pending", id: "Submit" }, { text: "Approved", id: "APPR" }, { text: "Rejected", id: "REJE" }, { text: "Draft", id: "Draft" }, { text: "Arrived", id: "Arrived" }];
        }
        this.buildForm();
    }

    public buildForm() {
        this.searchForm = this.formBuilder.group({
            status: this.formBuilder.control(null, []),
            serviceOrderId: this.formBuilder.control(null, []),
            contactEmail: this.formBuilder.control(null, []),
            faultDescription: this.formBuilder.control(null, []),
            lastUpdatedOn: this.formBuilder.control(null, []),
            returnReason: this.formBuilder.control(null, []),
            createdBy: this.formBuilder.control(null, []),
        });
    }

    public selectedDate(value: any) {
        this.searchParams['filters']['startDate'] = value.start.format('YYYY-MM-DD');
        this.searchParams['filters']['endDate'] = value.end.format('YYYY-MM-DD');
        this.searchParams['display']['Date Interval'] = value.start.format('MMMM D YYYY') + ' - ' + value.end.format('MMMM D YYYY');
    }

    public keyMapping(key) {
        for (let index of this.mapping) {
            if (index[key]) {
                return index[key];
            }
        }
    }

    public selected(value: any) {
        this.searchParams['filters']['status'].push(value.id);
        this.searchParams['display']['Status'].push(value.text);
    }

    public removed(value: any) {
        var index = this.searchParams['filters']['status'].indexOf(value.id);
        if (index >= 0) {
            this.searchParams['filters']['status'].splice(index, 1);
        }
        var index2 = this.searchParams['display']['Status'].indexOf(value.text);
        if (index2 >= 0) {
            this.searchParams['display']['Status'].splice(index2, 1);
        }
    }

    public search() {
        this.formData = this.searchForm.getRawValue();
        console.log(this.formData);
        for (let data in this.formData) {
            if (this.formData[data] && this.formData[data] != "") {
                this.searchParams['filters'][data] = this.formData[data];
                let key = this.keyMapping(data);

                if (data == 'reasonCode') {
                    if (this.reason && this.reason.length > 0) {
                        for (let r in this.reason) {
                            if (this.reason[r].reasonCode == this.formData[data]) {
                                this.searchParams['display'][key] = this.reason[r].reason;
                            }
                        }
                    }
                }
                if (data != 'status' && data != 'reasonCode') {
                    this.searchParams['display'][key] = this.formData[data];
                }
            }
        }
        this.commonService.changeSearchData(this.searchParams);
    }

    public closeDialog() {
        this.dialog.closeAll();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb_dashboard/icb_dashboard.component.ts